export const h = (key, options = {}) => {
  return { __html: I18n.t(key, options) }
}
